module.exports = __webpack_public_path__ + "static/media/USA-flag-circle.2732bdb5.png";